/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AdminAcquisitionDto,
    AdminAcquisitionDtoFromJSON,
    AdminAcquisitionDtoToJSON,
    AdminAnalyticsOverviewDto,
    AdminAnalyticsOverviewDtoFromJSON,
    AdminAnalyticsOverviewDtoToJSON,
    AdminAssetDistributionDto,
    AdminAssetDistributionDtoFromJSON,
    AdminAssetDistributionDtoToJSON,
    AdminChurnDto,
    AdminChurnDtoFromJSON,
    AdminChurnDtoToJSON,
    AdminFeatureAdoptionDto,
    AdminFeatureAdoptionDtoFromJSON,
    AdminFeatureAdoptionDtoToJSON,
    AdminImportUsageDto,
    AdminImportUsageDtoFromJSON,
    AdminImportUsageDtoToJSON,
    AdminStatisticsDto,
    AdminStatisticsDtoFromJSON,
    AdminStatisticsDtoToJSON,
    AdminUserActivityDto,
    AdminUserActivityDtoFromJSON,
    AdminUserActivityDtoToJSON,
} from '../models';

/**
 * 
 */
export class AdminStatisticsApi extends runtime.BaseAPI {

    /**
     * Get acquisition and conversion statistics
     */
    async adminStatisticsControllerGetAcquisitionRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<AdminAcquisitionDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/statistics/acquisition`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminAcquisitionDtoFromJSON(jsonValue));
    }

    /**
     * Get acquisition and conversion statistics
     */
    async adminStatisticsControllerGetAcquisition(initOverrides?: RequestInit): Promise<AdminAcquisitionDto> {
        const response = await this.adminStatisticsControllerGetAcquisitionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get statistics for admin
     */
    async adminStatisticsControllerGetAllRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<AdminStatisticsDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/statistics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminStatisticsDtoFromJSON));
    }

    /**
     * Get statistics for admin
     */
    async adminStatisticsControllerGetAll(initOverrides?: RequestInit): Promise<Array<AdminStatisticsDto>> {
        const response = await this.adminStatisticsControllerGetAllRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get asset distribution statistics
     */
    async adminStatisticsControllerGetAssetDistributionRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<AdminAssetDistributionDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/statistics/asset-distribution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminAssetDistributionDtoFromJSON(jsonValue));
    }

    /**
     * Get asset distribution statistics
     */
    async adminStatisticsControllerGetAssetDistribution(initOverrides?: RequestInit): Promise<AdminAssetDistributionDto> {
        const response = await this.adminStatisticsControllerGetAssetDistributionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get churn analysis including past due users and cancellation reasons
     */
    async adminStatisticsControllerGetChurnAnalysisRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<AdminChurnDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/statistics/churn-analysis`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminChurnDtoFromJSON(jsonValue));
    }

    /**
     * Get churn analysis including past due users and cancellation reasons
     */
    async adminStatisticsControllerGetChurnAnalysis(initOverrides?: RequestInit): Promise<AdminChurnDto> {
        const response = await this.adminStatisticsControllerGetChurnAnalysisRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get feature adoption statistics
     */
    async adminStatisticsControllerGetFeatureAdoptionRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<AdminFeatureAdoptionDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/statistics/feature-adoption`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminFeatureAdoptionDtoFromJSON(jsonValue));
    }

    /**
     * Get feature adoption statistics
     */
    async adminStatisticsControllerGetFeatureAdoption(initOverrides?: RequestInit): Promise<AdminFeatureAdoptionDto> {
        const response = await this.adminStatisticsControllerGetFeatureAdoptionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get import usage statistics by platform
     */
    async adminStatisticsControllerGetImportUsageRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<AdminImportUsageDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/statistics/import-usage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminImportUsageDtoFromJSON(jsonValue));
    }

    /**
     * Get import usage statistics by platform
     */
    async adminStatisticsControllerGetImportUsage(initOverrides?: RequestInit): Promise<AdminImportUsageDto> {
        const response = await this.adminStatisticsControllerGetImportUsageRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get analytics overview for admin dashboard
     */
    async adminStatisticsControllerGetOverviewRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<AdminAnalyticsOverviewDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/statistics/overview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminAnalyticsOverviewDtoFromJSON(jsonValue));
    }

    /**
     * Get analytics overview for admin dashboard
     */
    async adminStatisticsControllerGetOverview(initOverrides?: RequestInit): Promise<AdminAnalyticsOverviewDto> {
        const response = await this.adminStatisticsControllerGetOverviewRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get user activity statistics
     */
    async adminStatisticsControllerGetUserActivityRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<AdminUserActivityDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/statistics/user-activity`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminUserActivityDtoFromJSON(jsonValue));
    }

    /**
     * Get user activity statistics
     */
    async adminStatisticsControllerGetUserActivity(initOverrides?: RequestInit): Promise<AdminUserActivityDto> {
        const response = await this.adminStatisticsControllerGetUserActivityRaw(initOverrides);
        return await response.value();
    }

}
